/* ------------------------------------------------------------------
   Fios dourados — Jardim Brasil
   Um feixe de fios finos e semitransparentes atravessando a peca,
   com pulsos luminosos correndo por dentro, como impulsos neurais.

   <canvas class="jb-fios" data-jb-fios
           data-fios-cor="#B8912F"      cor do fio
           data-fios-pulso="#FFD98A"    cor do brilho que corre no fio
           data-fios-alfa="2.2"         multiplicador de opacidade
           data-fios-n="16"             fios do feixe
           data-fios-zona="cx,cy,rx,ry" elipse onde o fio some (o frasco)
   ></canvas>

   Em foto clara o fio precisa de cor mais fechada e alfa maior;
   em foto escura, o contrario. So anima com a secao visivel.
   Respeita prefers-reduced-motion (o CSS esconde a camada).
------------------------------------------------------------------- */
(function () {
  if (window.__jbFiosInit) return;
  window.__jbFiosInit = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) return;

  var dpr = Math.min(window.devicePixelRatio || 1, 2);
  var items = [];
  var raf = null;
  var t0 = performance.now();

  function hex2rgb(h) {
    h = (h || '').trim().replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    if (isNaN(n) || h.length !== 6) return [229, 208, 153];
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }

  function parseZonas(s) {
    if (!s) return [];
    return s.split(';').map(function (bloco) {
      var p = bloco.split(',').map(parseFloat);
      if (p.length < 4 || p.some(isNaN)) return null;
      return { cx: p[0], cy: p[1], rx: p[2], ry: p[3] };
    }).filter(Boolean);
  }

  /* quanto o fio "vive" naquele ponto: 0 dentro do frasco, 1 fora */
  function forcaEm(zonas, x, y) {
    var f = 1;
    for (var i = 0; i < zonas.length; i++) {
      var z = zonas[i];
      var dx = (x - z.cx) / (z.rx || .001);
      var dy = (y - z.cy) / (z.ry || .001);
      var d = Math.sqrt(dx * dx + dy * dy);
      var k = Math.min(1, Math.max(0, (d - .72) / .5));
      f = Math.min(f, k);
    }
    return f;
  }

  function fit(it) {
    var r = it.canvas.getBoundingClientRect();
    if (!r.width || !r.height) return false;
    var w = Math.round(r.width * dpr), h = Math.round(r.height * dpr);
    if (it.canvas.width !== w || it.canvas.height !== h) { it.canvas.width = w; it.canvas.height = h; }
    it.w = r.width; it.h = r.height;
    return true;
  }

  function yDoFio(it, fio, x, t) {
    var a = it.h * .17;
    var s = Math.sin((x * fio.freq + t * fio.vel + fio.fase) * Math.PI * 2);
    var s2 = Math.sin((x * fio.freq * 2.3 - t * fio.vel * .7 + fio.fase * 1.7) * Math.PI * 2);
    return fio.base * it.h + (s * .72 + s2 * .28) * a * fio.amp;
  }

  function desenha(it, t) {
    var ctx = it.ctx;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, it.w, it.h);
    ctx.lineCap = 'round';

    var passos = 46;
    var c = it.rgb;

    for (var f = 0; f < it.fios.length; f++) {
      var fio = it.fios[f];
      ctx.lineWidth = fio.esp;
      for (var i = 0; i < passos; i++) {
        var x0 = i / passos, x1 = (i + 1) / passos;
        var px0 = x0 * it.w, px1 = x1 * it.w;
        var py0 = yDoFio(it, fio, x0, t), py1 = yDoFio(it, fio, x1, t);
        var ponta = Math.min(1, Math.min(x0, 1 - x0) / .13);
        var viva = forcaEm(it.zonas, x0, py0 / it.h);
        var a = fio.alfa * ponta * viva * it.alfa;
        if (a <= .004) continue;
        ctx.strokeStyle = 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a.toFixed(3) + ')';
        ctx.beginPath();
        ctx.moveTo(px0, py0);
        ctx.lineTo(px1, py1);
        ctx.stroke();
      }
    }

    var pc = it.pulso;
    for (var p = 0; p < it.pulsos.length; p++) {
      var pu = it.pulsos[p];
      var fio2 = it.fios[pu.fio];
      var x = ((t * pu.vel + pu.off) % 1.3) - .15;
      if (x < 0 || x > 1) continue;
      var y = yDoFio(it, fio2, x, t);
      var viva2 = forcaEm(it.zonas, x, y / it.h);
      var borda = Math.min(1, Math.min(x, 1 - x) / .18);
      var respira = .55 + .45 * Math.sin(t * 1.6 + pu.off * 9);
      var a2 = .5 * viva2 * borda * respira * it.alfa;
      if (a2 <= .01) continue;
      if (a2 > .95) a2 = .95;
      var px = x * it.w;
      var g = ctx.createRadialGradient(px, y, 0, px, y, pu.r);
      g.addColorStop(0, 'rgba(' + pc[0] + ',' + pc[1] + ',' + pc[2] + ',' + a2.toFixed(3) + ')');
      g.addColorStop(.35, 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + (a2 * .5).toFixed(3) + ')');
      g.addColorStop(1, 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.arc(px, y, pu.r, 0, Math.PI * 2);
      ctx.fill();
    }
  }

  function frame(now) {
    raf = null;
    var t = (now - t0) / 1000;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (!it.visivel || document.hidden) continue;
      if (!fit(it)) continue;
      desenha(it, t);
      it.canvas.classList.add('is-on');
    }
    for (var k = 0; k < items.length; k++) { if (items[k].visivel) { raf = requestAnimationFrame(frame); break; } }
  }

  function acorda() { if (!raf) raf = requestAnimationFrame(frame); }

  function monta(canvas) {
    if (canvas.dataset.fiosOn) return;
    canvas.dataset.fiosOn = '1';

    var n = parseInt(canvas.dataset.fiosN, 10) || 14;
    var it = {
      canvas: canvas,
      ctx: canvas.getContext('2d'),
      rgb: hex2rgb(canvas.dataset.fiosCor || '#E5D099'),
      pulso: hex2rgb(canvas.dataset.fiosPulso || '#FFF6D6'),
      alfa: parseFloat(canvas.dataset.fiosAlfa) || 1,
      zonas: parseZonas(canvas.dataset.fiosZona),
      fios: [], pulsos: [], visivel: false, w: 0, h: 0
    };

    for (var i = 0; i < n; i++) {
      var k = i / (n - 1 || 1);
      it.fios.push({
        base: .5 + (k - .5) * .13,
        amp: .55 + Math.abs(k - .5) * .95,
        freq: .85 + k * .35,
        vel: .045 + k * .022,
        fase: k * 3.1 + Math.sin(i * 7.3) * .5,
        esp: 0.5 + (1 - Math.abs(k - .5) * 2) * 0.55,
        alfa: .10 + (1 - Math.abs(k - .5) * 2) * .16
      });
    }
    for (var j = 0; j < 3; j++) {
      it.pulsos.push({ fio: Math.floor(n * (.3 + j * .2)), vel: .055 + j * .012, off: j * .42, r: 26 + j * 6 });
    }

    items.push(it);

    function pintaJa() { if (fit(it)) { desenha(it, (performance.now() - t0) / 1000); it.canvas.classList.add('is-on'); } }
    it.pintaJa = pintaJa;
    pintaJa();

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) {
          it.visivel = e.isIntersecting;
          if (e.isIntersecting) { it.pintaJa(); acorda(); } else it.canvas.classList.remove('is-on');
        });
      }, { threshold: 0.05 });
      io.observe(canvas);
    } else { it.visivel = true; acorda(); }
  }

  function varre() { document.querySelectorAll('canvas[data-jb-fios]').forEach(monta); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', varre);
  else varre();
  document.addEventListener('shopify:section:load', varre);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) return;
    items.forEach(function (it) { if (it.visivel && it.pintaJa) it.pintaJa(); });
    acorda();
  });
  window.addEventListener('resize', acorda, { passive: true });
})();
